import { useNavigate } from "react-router-dom";
import { CardTransactionsPage as CardTransactionsPageView } from "@/components/CardTransactionsPage";

export function CardTransactionsPage() {
  const navigate = useNavigate();
  return <CardTransactionsPageView onSelect={(id) => navigate(`/expenses/${id}`)} />;
}
